module.exports = __webpack_public_path__ + "img/play-icon.bcd7d6bf.svg";